import { ContentProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import CitifaqHeader from "./CitifaqHeader";
import CitifaqSection from "./CitifaqSection";

export const CitifaqSectionEditorial = (props: ContentProps) => {
  const { model } = props.flexComponent;

  return (
    <>
      {model.title === "Citi_Faq_Section_Heading" && (
        <CitifaqHeader flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
      )}

      {model.title.includes("Citi_Faq_Section") && (
        <CitifaqSection flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
      )}
    </>
  );
};
export default CitifaqSectionEditorial;
